module.exports = __webpack_public_path__ + "assets/imgs/gmp/studio.f87e04f2ac3c4c27843612301c3c2443.svg";